/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { Procedure, Request, Worker } from '../../generated/graphql';
import { ISentence } from '../../pages/PlaygroundV3/components/Editor/editorInterface';

export enum MiniPlaygroundSourceType {
  TECHNIQUE = 'TECHNIQUE', // `Compute an answer` answer type
  LEARNING_SUGGESTION = 'LEARNING_SUGGESTION', // When a learning suggestion is clicked
  LEARNING_METHOD = 'LEARNING_METHOD', // When a learning method body is clicked
  SENTENCE = 'SENTENCE' // From sentence's menu
}

export enum MiniPlaygroundCallbackType {
  TECHNIQUE_DONE = 'TECHNIQUE_DONE',

  CBL_PREVIEW = 'CBL_PREVIEW',
  CBL_USE_METHOD = 'CBL_USE_METHOD',

  METHOD_LEARNING_UPDATE = 'METHOD_LEARNING_UPDATE',
  METHOD_LEARNING_USE_ANSWER = 'METHOD_LEARNING_USE_ANSWER'
}

export enum MethodLearningState {
  LOADING = 'LOADING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED'
}

export interface IMiniPlaygroundMetadata {
  procedure?: Procedure;
  request?: Request;
  methodLearningStateLifecycle?: Record<MethodLearningState, boolean>;
  methodLearningId?: string;
  methodLearningText?: string;
}

export interface IMiniPlaygroundCallbackData {
  editorText: string;
  miniPlaygroundToken: string;
  answer?: string;
  metadata: IMiniPlaygroundMetadata;
}

export type MiniPlaygroundCustomEvent = CustomEvent<{
  type: MiniPlaygroundCallbackType;
  data: IMiniPlaygroundCallbackData;
}>;

export interface IMiniPlaygroundProps {
  source: MiniPlaygroundSourceType;
  miniPlaygroundToken: string | null; // if null, a new mini playground will be created
  miniPlaygroundText?: string; // used to create a mini playground with a specific text block

  // the current document-related data
  document: {
    worker: Worker;
    sentence: ISentence;
    token: string;
  };

  // any supporting metadata for the mini playground, can contain any arbitrary data
  metadata: IMiniPlaygroundMetadata;

  onClose?: () => void;
}
